import { useEffect } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { syncAppLegalWebViewState } from "../../config/appWebViewLegal";

/**
 * Keeps `html.pi-app-legal-webview` in sync on SPA navigations between legal routes.
 * Cookie banner is suppressed via the same class (see index.html + pi-consent.js).
 */
export default function AppWebViewLegalShell() {
    const { pathname, search, hash } = useLocation();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        syncAppLegalWebViewState(pathname, searchParams, hash);
    }, [pathname, search, hash, searchParams]);

    return null;
}
